export default __webpack_public_path__ + "static/regulargap-56e15acc1fa66734eeb502b4eb6c03a0.png";